import { animate, style, transition, trigger } from "@angular/animations";

export const anims = trigger('appAnimation', [
     transition('* => *', [style({ opacity: .3, transform: "scale(.8) translateY(20%)"}),
        animate('.2s ease-in-out', style({ opacity: 1, transform: "scale(1) translateY(0)" })),
     ])
])